/**
 * Copyright (C) Techniserv, spol. s r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

function updateCharacterCount(textarea, textareaLetterCount) {
  const maxLength = parseInt(textarea.getAttribute('maxlength'));
  const currentLength = textarea.value.length;

  textareaLetterCount.textContent = currentLength + '/' + maxLength;
}

export default function({namespace}) {
  const textareaForm = document.createElement('div')
  textareaForm.id = `${namespace}feedback_message_div`
  textareaForm.classList.add('gov-form-control', 'gov-form-control--classic', 'feedback_textarea_form')

  const textarea = document.createElement('textarea')
  textarea.id = `${namespace}feedback_user_message`
  textarea.classList.add('gov-form-control__input', 'feedback_textarea')
  textarea.ariaRequired = false
  textarea.placeholder = Liferay.Language.get('articlefeedback.includeReasons')
  textarea.maxLength = 250

  const textareaLetterCount = document.createElement('span')
  textareaLetterCount.classList.add('gov-form-control__message')
  textareaLetterCount.innerText = '0/250'
  textarea.oninput = function () { updateCharacterCount(textarea, textareaLetterCount) }

  const textareaLabel = document.createElement('label')
  textareaLabel.classList.add('gov-form-control__label')
  textareaLabel.innerText = Liferay.Language.get('articlefeedback.reviewComment')
  textareaLabel.htmlFor = `${namespace}feedback_user_message`

  const textareaValidationMark = document.createElement('span')
  textareaValidationMark.classList.add('gov-form-control__validation-mark')
  textareaValidationMark.tabIndex = -1

  textareaForm.append(textarea, textareaLabel, textareaLetterCount, textareaValidationMark)
  return textareaForm
}
